import { useEffect, useRef } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const services = [
  {
    icon: "ri-briefcase-4-line",
    title: "Développement d'affaires",
    tag: "Stratégie",
    description:
      "Information stratégique incluant plans d'affaires, devis et corrections. Formation en entreprise pour améliorer la productivité. Montage financier et solutions de financement adaptées.",
    link: "https://Facebook.com/steptin",
    linkLabel: "Facebook.com/steptin",
  },
  {
    icon: "ri-focus-3-line",
    title: "Performance — PAIR-FORME 5.0",
    tag: "Coaching",
    description:
      "Coaching pour motivation, performance et élimination du syndrome de l'imposteur. Programmation mentale et physique avec FOCUS GYM 5.0. Durée : 52 semaines, en groupe de 4 ou individuel.",
    link: "https://Facebook.com/leaderstephane",
    linkLabel: "Facebook.com/leaderstephane",
  },
  {
    icon: "ri-exchange-line",
    title: "Logistique — WEB TRADE CENTER",
    tag: "Commerce",
    description:
      "Gestion d'articles de seconde main : ordinateurs, équipements, mobilier. Recherche d'acheteurs pour propriétés, terrains et bâtiments mobiles.",
    link: "https://Facebook.com/steptin1970",
    linkLabel: "Facebook.com/steptin1970",
  },
  {
    icon: "ri-home-gear-line",
    title: "Entretien ménager — Beauce",
    tag: "Services",
    description:
      "Agroalimentaire : conseil sanitaire et expérience HACCP. Services : lavage de fenêtres, tapis, entretien hebdomadaire (bureaux, planchers, aspirateur).",
    link: null,
    linkLabel: null,
  },
];

export default function MissionServices() {
  const titleRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            (entry.target as HTMLElement).style.opacity = "1";
            (entry.target as HTMLElement).style.transform = "translateY(0)";
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll(".fade-in-up").forEach((el) => {
      (el as HTMLElement).style.opacity = "0";
      (el as HTMLElement).style.transform = "translateY(30px)";
      (el as HTMLElement).style.transition = "opacity 0.7s ease, transform 0.7s ease";
      observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-white" style={{ fontFamily: "'Montserrat', sans-serif" }}>
      <Navbar />

      {/* Hero Split */}
      <section className="pt-20 min-h-[70vh] flex flex-col lg:flex-row">
        {/* Photo */}
        <div className="w-full lg:w-1/2 h-64 lg:h-auto relative overflow-hidden">
          <img
            src="https://static.readdy.ai/image/2ff205c826c7478ce4cffa1fe381bc88/99c4947665f0881b9e1c03c3b8d4ac49.png"
            alt="Mission & Services"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/20 to-transparent" />
        </div>

        {/* Title */}
        <div className="w-full lg:w-1/2 flex items-center bg-white px-8 md:px-16 py-16">
          <div ref={titleRef}>
            <p className="text-xs font-semibold tracking-[0.3em] uppercase text-amber-500 mb-4">
              Notre raison d&apos;être
            </p>
            <div className="flex items-start gap-4 mb-6">
              <div className="w-1 h-16 bg-amber-500 flex-shrink-0 mt-1" />
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
                Mission &amp;<br />Services
              </h1>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed max-w-md">
              Une approche personnalisée pour chaque projet, chaque entreprise, chaque ambition.
            </p>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="py-20 px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto fade-in-up">
          <p className="text-xs font-semibold tracking-[0.3em] uppercase text-amber-500 mb-10">
            Mission
          </p>
          <div className="flex flex-col lg:flex-row gap-12 items-center">
            {/* Image */}
            <div className="w-full lg:w-2/5 flex-shrink-0">
              <div className="w-full h-72 lg:h-96 rounded-lg overflow-hidden">
                <img
                  src="https://storage.readdy-site.link/project_files/0682dcc1-8116-482a-86bc-da6c1cbe6059/e575dc48-0bdb-4019-ad57-01bb5257c4bb_668932182_1314516390548008_2790623131751033989_n.jpg?v=6997476aa2e410d8344398176cc51839"
                  alt="Stéphane Boutin - Mission"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
            {/* Text */}
            <div className="w-full lg:w-3/5">
              <div className="border-l-4 border-amber-500 pl-8">
                <p className="text-gray-700 text-base md:text-lg leading-relaxed mb-6">
                  <strong>stephane-boutin.com</strong> offre une aide personnalisée et adaptée aux projets d&apos;affaires. Analyse des entreprises et réseaux pour identifier les obstacles, puis mise en place de solutions concrètes.
                </p>
                <p className="text-gray-600 text-base leading-relaxed">
                  Pour les projets en démarrage : accompagnement après consultation des ressources MRC et organismes. Si insatisfaction, rencontre personnalisée d&apos;une heure.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 px-6 bg-white">
        <div className="max-w-6xl mx-auto">
          <p className="text-xs font-semibold tracking-[0.3em] uppercase text-amber-500 mb-12 text-center fade-in-up">
            Nos services
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {services.map((service, idx) => (
              <div
                key={service.title}
                className="fade-in-up bg-gray-50 rounded-lg p-8 border border-gray-100 hover:border-amber-200 hover:shadow-md transition-all duration-300 flex flex-col"
                style={{ transitionDelay: `${idx * 0.1}s` }}
              >
                <div className="flex items-center gap-4 mb-5">
                  <div className="w-12 h-12 flex items-center justify-center bg-amber-50 rounded-lg">
                    <i className={`${service.icon} text-2xl text-amber-500`} />
                  </div>
                  <span className="text-xs font-semibold tracking-widest uppercase text-amber-500 bg-amber-50 px-3 py-1 rounded-full">
                    {service.tag}
                  </span>
                </div>
                <h2 className="text-lg font-bold text-gray-900 mb-4 leading-snug">{service.title}</h2>
                <p className="text-gray-600 text-sm leading-relaxed flex-1">{service.description}</p>
                {service.link && (
                  <a
                    href={service.link}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="mt-6 inline-flex items-center gap-2 text-xs font-semibold text-amber-600 hover:text-amber-700 transition-colors duration-200 cursor-pointer"
                  >
                    <i className="ri-facebook-circle-fill text-base" />
                    {service.linkLabel}
                    <i className="ri-arrow-right-line text-xs" />
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
